import { useNavigate } from 'react-router-dom';
import { useToast } from '@urbanx/agx.ui-components2';
import { Pages } from 'constants/menu';
import { useAutomationFailureNotifications } from 'hooks/useAutomationFailureNotifications';
import { useEffect } from 'react';

export const AUTOMATION_FAILURE_TOAST_ID = 'automation-failure-notification';

export const useAutomationFailureNotifier = () => {
  const navigate = useNavigate();
  const { pushToast, removeToast } = useToast();

  useAutomationFailureNotifications((notification) => {
    const campaignPath =
      notification.agencyId && notification.campaignId
        ? `/${Pages.AGENCIES}/${notification.agencyId}/${Pages.CAMPAIGNS}/${notification.campaignId}/${Pages.CAMPAIGN_ERRORS}`
        : undefined;

    pushToast(
      {
        type: 'error',
        message: `${notification.automationName} failed`,
        subtitle: notification.campaignAddress ?? undefined,
        dismissible: true,
        action: campaignPath
          ? {
              label: 'View',
              onClick: () => {
                removeToast(AUTOMATION_FAILURE_TOAST_ID);
                navigate(`${campaignPath}?failure=${encodeURIComponent(notification.reference)}`);
              },
            }
          : undefined,
      },
      AUTOMATION_FAILURE_TOAST_ID
    );
  });

  useEffect(() => () => removeToast(AUTOMATION_FAILURE_TOAST_ID), [removeToast]);
};
